module.exports = __webpack_public_path__ + "img/leumi_riseup_friends.81176116.svg";